import type {
  PublicSpeakerSignupNode,
  PublicSpeakerSignupNodeType,
} from '@govinity/validation/public';

export const publicSpeakerOptionsQueryKey = (governmentCode: string, meetingId: number) => [
  'portal-public-speaker-options',
  governmentCode,
  meetingId,
];

export const publicSpeakerUserSignupsQueryKey = (governmentCode: string, meetingId: number) => [
  'portal-public-speaker-user-signups',
  governmentCode,
  meetingId,
];

/**
 * A sign-up target is either an agenda section or a legislative item placed on one, and the two id
 * spaces are unrelated — so anything keyed by target has to carry the node type alongside the id.
 */
export const toEntryKey = ({
  id,
  type,
}: {
  id: number;
  type: PublicSpeakerSignupNodeType;
}): string => `${type}:${id}`;

/** Whether the tree offers anything a citizen can actually pick. */
export const hasSelectableEntry = (nodes: PublicSpeakerSignupNode[]): boolean =>
  nodes.some((node) => !node.disabled || hasSelectableEntry(node.children));

/** Whether anything is left to sign up for once the citizen's existing sign-ups are excluded. */
export const hasAvailableEntry = (
  nodes: PublicSpeakerSignupNode[],
  signedUpKeys: Set<string>
): boolean =>
  nodes.some(
    (node) =>
      (!node.disabled && !signedUpKeys.has(toEntryKey(node))) ||
      hasAvailableEntry(node.children, signedUpKeys)
  );
